import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {useMultiStyleConfig, VStack} from '@chakra-ui/react'
import BenefitCard from './benefit-card'
import {CheckIcon} from '../icons'
import {delivery, returns, garanzia} from './benefit-labels'

const Benefits = () => {
    const styles = useMultiStyleConfig('Benefits')
    const intl = useIntl()

    return (
        <VStack {...styles.benefitStack}>
            <BenefitCard
                icon={<CheckIcon {...styles.icon} />}
                strongText={<FormattedMessage {...delivery.strongText} />}
                normalText={<FormattedMessage {...delivery.normalText} />}
                infoPopoverTitle={intl.formatMessage(delivery.infoPopover.title)}
                infoPopoverDescription={intl.formatMessage(delivery.infoPopover.description)}
            />

            <BenefitCard
                icon={<CheckIcon {...styles.icon} />}
                strongText={<FormattedMessage {...returns.strongText} />}
                normalText={<FormattedMessage {...returns.normalText} />}
                infoPopoverTitle={intl.formatMessage(returns.infoPopover.title)}
                infoPopoverDescription={intl.formatMessage(returns.infoPopover.description)}
            />

            <BenefitCard
                icon={<CheckIcon {...styles.icon} />}
                strongText={<FormattedMessage {...garanzia.strongText} />}
                normalText={<FormattedMessage {...garanzia.normalText} />}
                infoPopoverTitle={intl.formatMessage(garanzia.infoPopover.title)}
                infoPopoverDescription={intl.formatMessage(garanzia.infoPopover.description)}
            />
        </VStack>
    )
}

export default Benefits
